var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCheck4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_672_5168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3493 7.49906C16.6918 9.17987 16.4477 10.9273 15.6578 12.4499C14.8678 13.9726 13.5797 15.1784 12.0083 15.8663C10.437 16.5541 8.67725 16.6825 7.02266 16.23C5.36807 15.7775 3.91862 14.7714 2.91603 13.3796C1.91343 11.9877 1.4183 10.2942 1.5132 8.5815C1.6081 6.86877 2.28729 5.24034 3.43751 3.96777C4.58773 2.6952 6.13945 1.85542 7.8339 1.58846C9.52836 1.3215 11.2631 1.64351 12.7489 2.50078",
    stroke: "#00A63E",
    strokeWidth: 1.49986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74927 8.2495L8.99906 10.4993L16.4983 3",
    stroke: "#00A63E",
    strokeWidth: 1.49986,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_672_5168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9983,
    height: 17.9983,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck4);
export default __webpack_public_path__ + "static/media/green_check4.02ce73de99ce1c3ba9fef9a82c532a98.svg";
export { ForwardRef as ReactComponent };